export default {"src":"/_next/static/media/locked-in-price.d6645037.svg","height":194,"width":215};